
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeItemGrid extends Serenity.EntityGrid<PsDiscCouponTypeItemRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeItemColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeItemDialog; }
        protected getIdProperty() { return PsDiscCouponTypeItemRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeItemRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeItemRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}